export class OrderShippingPackage {
  public id: number;
  constructor(
    public width: number,
    public height: number,
    public length: number,
    public weight: number,
    public quantity: number,
    public dimensionUnit: string,
    public weightUnit: string,
  ) { }
}
